<div id="top"></div>
<div class="container-fluid p-0">

  <div class="container">
    <!--Navbar-->
    <mdb-navbar SideClass="navbar fixed-top navbar-expand-lg navbar-light" [containerInside]="false">

      <!-- Navbar brand -->
      <mdb-navbar-brand><a class="navbar-brand" style="padding-left: 20px;"><img src="/assets/Image/logo.png" alt=""
            width="250" height="70"></a></mdb-navbar-brand>

      <!-- Collapsible content -->
      <links>

        <!-- Links -->
        <ul class="navbar-nav ml-auto">
          <li class="nav-item ">
            <a id="upload" (click)="uploadBtn()" class="nav-link waves-light" mdbWavesEffect>
              UPLOAD
            </a>
          </li>
          <li class="nav-item">
            <a id="remove" (click)="removeBtn()" class="nav-link waves-light" mdbWavesEffect>
              REMOVE
            </a>
          </li>
          <li class="nav-item">
            <a id="messages" (click)="viewBtn()" class="nav-link waves-light" mdbWavesEffect>
              VIEW MESSAGES
            </a>
          </li>
        </ul>
        <!-- Links -->
      </links>
      <!-- Collapsible content -->

    </mdb-navbar>
    <!--/.Navbar-->

    <!--Upload-->
    <div *ngIf="up==true">
      <div class="title">
        <h2 style="font-size: 40px;">Upload</h2>
        <p style="font-size: 20px; color: #f79c09ce; font-family: cursive; text-align: center;"><i>Upload an
            Adventure</i></p>
      </div>
      <form [formGroup]="formTemp" (submit)="onSubmiting(formTemp.value)" align="center">

        <div *ngIf="showImg == true" class="text-center">
          <img class="mdb-card-img" [src]="img" alt="Card image cap" (click)="fileUploader.click()" align="center">

        </div>

        <br>

        <div class="form-group">
          <label>Select An Image: </label>
          <input type="file" accept="image/*" class="form-control" #fileUploader formControlName="imageUrl"
            (change)="showPreview($event)">
          <div class="text-danger" *ngIf="isSubmit && formControls.imageUrl.errors?.required">This field is required.
          </div>
        </div>

        <div class="form-group">
          <input type="text" class="form-control" formControlName="title" placeholder="Title">
          <div class="text-danger" *ngIf="isSubmit && formControls.title.errors?.required">This field is required.</div>
        </div>

        <div class="form-group">
          <select formControlName="category" class="form-control">
            <option value="Attraction" selected>Attraction</option>
            <option value="Transport">Transport</option>
            <option value="Accommodation">Accommodation</option>
            <option value="Food">Food & Beverage</option>
          </select>
        </div>

        <div class="form-group">
          <textarea rows="5" formControlName="descrip" placeholder="Description"></textarea>
          <div class="text-danger" *ngIf="isSubmit && formControls.descrip.errors?.required">This field is required.
          </div>
        </div>

        <div class="form-group">
          <button type="submit" class="btn btn-success float-right">Submit</button>
        </div>

      </form>
    </div>
  </div>
  <!--Upload-->

  <!--Remove-->
  <div *ngIf="rem==true">
    <div style="background-color: #ffc76e1a; padding: 20px;">
      <div class="container">
        <div class="title">
          <h1>Remove</h1>
          <p style="font-size: 20px; color: #f79c09ce; font-family: cursive; text-align: center;"><i>Remove an
              Adventure</i></p>
        </div>




        <div class="row justify-content-center" style="margin-top: 50px; text-align: center;">

          <!-- Image-->
          <div class="col-sm-6 pb-2" *ngFor="let r of imageList">
            <!-- Card -->
            <div class="card">

              <div class="view overlay">
                <img [src]="r.imgUrl" alt="Card image cap" class="img-fluid" (click)="basicModal.show()">

              </div>
              <br><br>
              <p class="descr">
                <b>
                  <h4>{{r.title}}</h4>
                </b>
                <br>
                Category: {{r.category}}
                <br>
                <a mdbBtn color="primary" mdbWavesEffect (click)="remove(r.id)">Remove</a>

                <!--Popup-->
              <div mdbModal #basicModal="mdbModal" class="modal fade bottom" tabindex="-1" role="dialog"
                aria-labelledby="myBasicModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-scrollable" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <button type="button" class="close pull-right" aria-label="Close" (click)="basicModal.hide()">
                        <span aria-hidden="true">×</span>
                      </button>
                      <h4 class="modal-title w-100" id="myModalLabel">{{r.title}}</h4>
                    </div>
                    <div class="modal-body">
                      <img [src]="r.imgUrl" class="img-fluid" alt="Sample image with waves effect.">
                      <br>
                      <p style="padding-top: 30px;">
                        {{r.descrip}}
                      </p>
                    </div>

                  </div>
                </div>
              </div>
              <!--Popup-->
            </div>
            <!-- Card -->
          </div>
          <!-- Image-->
        </div>
      </div>

    </div>
  </div>
  <!--Remove-->

  <!--View Messages-->
  <div *ngIf="view==true">
    <div style="padding: 20px;">
      <div class="container">
        <div class="title">
          <h1>Messages</h1>
          <p style="font-size: 20px; color: #f79c09ce; font-family: cursive; text-align: center;"><i>View Messages from clients.</i></p>
        </div>

        <div class="row justify-content-center" style="margin-top: 50px; text-align: center;">

          <!-- Image-->
          <div class="col-sm-6 pb-2" *ngFor="let m of messages">
            <!-- Card -->
            <div class="card2">             
              
              <p class="descr">
                <b>
                  <h4>{{m.firstName}} {{m.lastName}}</h4>
                </b>
                <br>
                Email Address: {{m.email}}
                <br>
                Phone Number: {{m.pNumber}}
                <br>
                Date: {{m.date |  date: 'dd MMM yyyy, hh:mm a'}}
               <br><br>
               Message: {{m.message}}             
              </p>
              <a mdbBtn color="primary" mdbWavesEffect (click)="removeMessage(m.id)">Remove</a>               
            </div>
            <!-- Card -->
          </div>
          <!-- Image-->
        </div>
      </div>

    </div>
  </div>
  <!--View Messages-->

  <div class="signOut">
    <button (click)="logout()" mdbBtn type="button" color="danger" mdbWavesEffect>Sign Out</button>
  </div>
</div>

<button (click)="topFunction()" id="myBtn" title="Go to top"><i class="fas fa-arrow-up"></i></button>
